import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoShipment } from '@pit/frontend-model';
import { Observable } from 'rxjs';
import { DtoShipmentStoreFactory } from './dto.shipment.store.factory';

@Injectable()
export class DtoShipmentEffects extends EntityStoreEffects<IDtoShipment> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.shipment', actions$, DtoShipmentStoreFactory.instance, dataServiceAccessor);
    }

    loadShipmentsForShipmentData$: Observable<Action> = DtoShipmentStoreFactory.instance.getEffect('get.by.date')(this.actions$, this.dataServiceAccessor);

    loadShipmentsActiveForUser$: Observable<Action> = DtoShipmentStoreFactory.instance.getEffect('get.active.by.user')(this.actions$, this.dataServiceAccessor);

    loadShipmentsActiveForDepot$: Observable<Action> = DtoShipmentStoreFactory.instance.getEffect('get.active.by.depot')(this.actions$, this.dataServiceAccessor);

    loadShipmentsToReturnForDepot$: Observable<Action> = DtoShipmentStoreFactory.instance.getEffect('get.returns.by.depot')(this.actions$, this.dataServiceAccessor);
}
